import React from 'react';

function Footer() {
  return (
    <footer style={{bottom:"0px"}}>
    </footer>
  )
}

export default Footer;